import React from 'react';
import { Typeahead } from "react-bootstrap-typeahead";
import PhysicalLocation, { getPhysicalLocationDisplayName } from "domain/physicalLocation";
import { useSelector } from 'react-redux';
import IAppStore from 'app/IAppStore';
import useUniqueId from 'common/ui/useUniqueId';

export interface LocationPickerProps {
    onLocationSelected(location: PhysicalLocation): void;
    locations: PhysicalLocation[];
    placeholder?: string;
    selected?: PhysicalLocation;
    disabled?: boolean;
    required: boolean;
}

const LocationPicker: React.FC<LocationPickerProps> = props => {
    const componentId = useUniqueId();
    const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);

    function onAutoCompleteValueChanged(selectedItem: any[]) {
        props.onLocationSelected(selectedItem[0]);
    }

    return <Typeahead
        id={componentId}
        clearButton
        disabled={props.disabled}
        inputProps={{ required: props.required, className: props.selected == null ? "font-weight-bold": "" }}
        placeholder={props.placeholder}
        labelKey={l => getPhysicalLocationDisplayName(l, isCustomer)}
        options={props.locations}
        selected={props.selected ? [props.selected] : []}
        onChange={(ev) => onAutoCompleteValueChanged(ev)}
    />
}

export default LocationPicker;